import React from 'react'

import View from './View'

const Container = ({textData, closeModal}) => {
  
    return <View title="Cadastro Cliente" textData={textData} closeModal={closeModal}/>}

export default Container
